<!--
 * @Author: wsx
 * @Date: 2022-01-05 20:40:07
 * @LastEditTime: 2022-02-14 10:31:32
 * @LastEditors: Please set LastEditors
 * @Description: 菜单树
-->
<template>
  <component
    :is="isMenu(menu.list)"
    :index="menu.url || menu.menuId + ''"
    @click="clickMenuItem(menu)"
  >
    <template #title>{{ menu.name }}</template>
    <template v-if="menu.list && menu.list.length > 0">
      <menu-tree
        v-for="i in menu.list"
        :key="'menu' + i.menuId"
        :menu="i"
      ></menu-tree>
    </template>
  </component>
</template>
<script>
import { defineComponent, reactive, toRefs, toRaw } from "vue";
import { useContext } from "@/hooks/core/useContext.js";
export default defineComponent({
  name: "MenuTree",
  components: {},
  props: {
    menu: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const data = reactive({});
    const refData = toRefs(data);
    const { clickMenu } = useContext("menuRoot");
    const isMenu = a => {
      const template = a && a.length > 0 ? "el-sub-menu" : "el-menu-item";

      return template;
    };
    const clickMenuItem = item => {
      clickMenu(toRaw(item));
    };
    return { ...refData, isMenu, clickMenuItem };
  }
});
</script>
<style lang="scss" scoped>
.MenuTree {
}
</style>
